(function () {
    'use strict';

    angular
        .module('campaignStatusMgmtModule')
        .controller('ODDExternalPartiesController', Controller);

    Controller.$inject = ['$scope', '$state', 'topBarService', 'progressBlocks', 'businessUnit'];

    function Controller($scope, $state, topBarService, progressBlocks, businessUnit) {

        topBarService.setTitleAndIcon('Operational Due Diligence | ' + businessUnit.TitleEN, 'icon icon-clipboard');
        
        $scope.externalParties = [];
        
        progressBlocks.ODDProgressBlocks.forEach(function (progressBlock) {
            progressBlock.ODDExternalParty.Campaigns = progressBlock.ODDCampaignProgressBlocks;
            $scope.externalParties.push(progressBlock.ODDExternalParty)
        });

        $scope.createExternalParty = function () {
            $state.go('odd.addExternalParty');
        };

        $scope.goToExternalPartyOrCampaign = function(externalPartyID) {
            // Else go to External Party edit
            $state.go('odd.externalPartyEdit', { ODDExternalPartyID: externalPartyID })
        };

        $scope.goToCampaign = function (externalPartyID,campaign) {
            $state.go('odd.externalPartyEdit.campaign', {
                ODDExternalPartyID: externalPartyID,
                ODDCampaignID: campaign.ODDCampaignID
            });
        };

    }
})();